import {
  PRODUTOS_POR_LICENCA,
  moduloApenasContador,
  moduloOcultoUI,
} from "./modulosLicenca";

export const UNIDADES_COBRANCA = [
  { value: "licenca", label: "Por licença" },
  { value: "terminal", label: "Por terminal" },
  { value: "empresa", label: "Por empresa" },
  { value: "dispositivo", label: "Por dispositivo" },
  { value: "estabelecimento", label: "Por estabelecimento" },
  { value: "mes", label: "Por mês" },
];

export const SECOES_PRECO_LICENCA = [
  {
    licencaTipo: "ZenGestao",
    titulo: "ZenGestão",
    subtitulo:
      "Licença base inclui 1 PDV, gestão, cadastros, estoque, fornecedores e NF-e. Multi estoque, orçamentos e os demais adicionais são cobrados à parte.",
    moduloBaseCodigo: "GESTAO_BASE",
  },
  {
    licencaTipo: "ZenPDV",
    titulo: "ZenPDV Desktop",
    subtitulo: "1 terminal ZenPDV Desktop incluso. PDVs adicionais cobrados por terminal.",
    moduloBaseCodigo: "PDV_BASE",
  },
  {
    licencaTipo: "ZenTag",
    titulo: "ZenTag",
    subtitulo: "Licença base do ZenTag.",
    moduloBaseCodigo: "ZENTAG_BASE",
  },
  {
    licencaTipo: "ZenMobile",
    titulo: "ZenMobile",
    subtitulo: "Licença base do ZenMobile.",
    moduloBaseCodigo: "ZENMOBILE_BASE",
  },
  {
    licencaTipo: "ZenPass",
    titulo: "ZenPass",
    subtitulo: "Licença base do ZenPass, cobrada por mês.",
    moduloBaseCodigo: "ZENPASS_BASE",
  },
];

export function unidadePadraoPreco(codigo, licencaTipo) {
  if (codigo === "ADD_EMPRESA") return "empresa";
  if (
    codigo === "ADD_ZENPAY" ||
    codigo === "ADD_PDV_POS" ||
    codigo === "ADD_PDV_ADICIONAL" ||
    codigo === "ADD_AUTOATENDIMENTO" ||
    codigo === "ADD_PREVENDA"
  ) {
    return "terminal";
  }
  if (codigo === "ADD_WHATSAPP") return "estabelecimento";
  if (codigo === "ADD_INVENTARIO") return "dispositivo";
  if (codigo === "ADD_MULTI_ESTOQUE" || codigo === "ADD_ORCAMENTO") return "licenca";
  if (licencaTipo === "ZenTag" || licencaTipo === "ZenMobile" || licencaTipo === "ZenPass") return "mes";
  return "licenca";
}

export function labelUnidadePreco(unidade) {
  return UNIDADES_COBRANCA.find((u) => u.value === unidade)?.label || unidade;
}

export function modulosPrecoPorSecao(modulos, secao) {
  // Na UI de licença as bases ficam ocultas (já inclusas); na tabela de preço elas precisam aparecer.
  const visiveis = (modulos || []).filter((m) => {
    const produtos = PRODUTOS_POR_LICENCA[secao.licencaTipo] || [];
    if (!produtos.includes(m.produto)) return false;

    if (secao.licencaTipo === "ZenGestao" && (m.codigo === "PDV_BASE" || m.codigo === "ADD_PDV_POS")) {
      return false;
    }
    if (secao.licencaTipo === "ZenPDV" && (m.codigo === "ADD_PDV_POS" || m.produto === "Transversal")) {
      return false;
    }

    const oculto = moduloOcultoUI(m.codigo, secao.licencaTipo);
    if (oculto && m.codigo !== secao.moduloBaseCodigo) return false;

    return true;
  });

  const base = visiveis.find((m) => m.codigo === secao.moduloBaseCodigo) || null;
  const adicionais = visiveis.filter((m) => m.codigo !== secao.moduloBaseCodigo);
  return { base, adicionais };
}

/** Monta linhas de preço por seção sem repetir módulo (transversais aparecem na 1ª seção). */
export function linhasPrecoPorSecoes(modulos) {
  const exibidos = new Set();
  return SECOES_PRECO_LICENCA.map((secao) => {
    const { base, adicionais } = modulosPrecoPorSecao(modulos, secao);
    const linhas = [];

    if (base && !exibidos.has(base.id)) {
      exibidos.add(base.id);
      linhas.push({ modulo: base, tipo: "base", secao });
    }

    adicionais.forEach((modulo) => {
      if (exibidos.has(modulo.id)) return;
      exibidos.add(modulo.id);
      linhas.push({
        modulo,
        tipo: moduloApenasContador(modulo.codigo, secao.licencaTipo) ? "contador" : "adicional",
        secao,
      });
    });

    return { secao, linhas };
  }).filter((bloco) => bloco.linhas.length > 0);
}

export const parseValorPreco = (str) => {
  if (str === "" || str == null) return 0;
  const n = Number(String(str).replace(/\./g, "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const formatValorPrecoInput = (n) => {
  if (!n || n === 0) return "";
  return Number(n).toFixed(2).replace(".", ",");
};
